// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `start-tour-button .start-tour-button {
  min-width: 145px;
}
start-tour-button .start-tour-button .svg-text {
  padding: 0 15px;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/start-tour-button/start-tour-button.component.scss"],"names":[],"mappings":"AAEI;EACI,gBAAA;AADR;AAGQ;EACI,eAAA;AADZ","sourcesContent":["start-tour-button {\n\n    .start-tour-button {\n        min-width: 145px;\n\n        .svg-text {\n            padding: 0 15px\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
